import { catchError, firstValueFrom, map, Observable, throwError } from 'rxjs';
import { ResponseBase } from '../models/ResponseBase';
import { ApiResponse, PageableResponse as PagableResponse } from '../models/ApiResponse';

export type AwaitableObservable<T> = Observable<T> & PromiseLike<T>;

export function createAwaitable<T>(source$: Observable<T>): AwaitableObservable<T> {
    (source$ as any)['then'] = (onfulfilled?: (value: T) => any | PromiseLike<any>, onrejected?: (reason: any) => any | PromiseLike<any>) => firstValueFrom(source$).then(onfulfilled, onrejected);
    return <any>source$;
}
export function extractError(e?: any): string {
    if (e.error && typeof e.error === 'object') return extractError(e.error);
    if (e.Error && typeof e.Error === 'object') return extractError(e.Error);
    let error = e?.Message ?? e?.message;
    const errorData = e?.error ?? e?.Error ?? e?.Data ?? e?.data;

    if (typeof errorData === 'string') {
        if (error && error != 'Internal Server Error') {
            error = error + ': ' + errorData;
        } else {
            error = errorData;
        }
    }
    return error || 'Internal Server Error';
}

export function createAwaitableApiResponse<T, TResponse extends ApiResponse<T>>(source$: Observable<TResponse>, onError?: (e: any) => Observable<any> | void): AwaitableObservable<T> {

    return createAwaitable(source$.pipe(
        map((response: ApiResponse<T>) => {
            if (response?.StatusCode != 200) {
                throw new Error(extractError(response));
            } else {
                let res = response?.Data ?? response?.Data;
                // если результат - это PagableResponse<T> превратим его в T[], но с сохранением данных о постраничной загрузке
                const pr = (res as PagableResponse<T>);
                if (pr.$pageNumber && pr.$pageSize && Array.isArray(pr.data)) {
                    res = <T>pr.data;
                    const respr = (res as PagableResponse<T>);
                    respr.$pageNumber = pr.$pageNumber;
                    respr.$pageSize = pr.$pageSize;
                    respr.$totalRecords = pr.$totalRecords;
                    respr.data = pr.data;
                }
                return res;
            }
        }),
        catchError(e => {
            const res = typeof onError === 'function' ? onError(e) : null;
            return res ? res : throwError(() => e);
        })
    ));
}

export function createAwaitableResponseBase<T extends ResponseBase>(source$: Observable<T>, onError?: (e: any) => Observable<any> | void): AwaitableObservable<T> {
    return createAwaitable(source$.pipe(
        map(data => {
            if (data.hasValidationErrors) {
                throw new Error(data.validationErrorMessage);
            } else {
                return data;
            }
        }),
        catchError(e => {
            const res = typeof onError === 'function' ? onError(e) : null;
            return res ? res : throwError(() => e);
        })
    ));
}